import { render, staticRenderFns } from "./basic-menu-item.vue?vue&type=template&id=b838eb86&functional=true&"
import script from "./basic-menu-item.vue?vue&type=script&lang=js&"
export * from "./basic-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports